import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, UserDetails, UserTypes } from '../../service';
import { UserControlService } from "src/app/air/modules/common/service/userControl/user-control.service";
import { CommonService } from "src/app/air/modules/common/service/common/common.service";
import { EFeatures } from 'src/app/air/modules/common/lib/model/common';
import { AirAppRoutes } from 'src/app/air/modules/common/lib/air-api-constant';

@Injectable({
  providedIn: 'root'
})
export class AccessGuard implements CanActivate, CanActivateChild, CanLoad {
  private features: any = {
    admin: { access: false, routes: [] },
    exceptionManagement: { access: false, routes: [] },
    liveTracking: { access: false, routes: [] },
    eventTracking: { access: true, routes: [] },
    reporting:{access: false, routes: []},
    dataUpload:{access:false,routes:[]}
  };
  constructor(
    private userControlService: UserControlService,
    private authService: AuthService,
    private commonService: CommonService) {
    this.features.reporting.route=[this.commonService.getRoute({ route: AirAppRoutes.User.REPORTING_DASHBOARD, type: 'Manager' })];
    this.features.dataUpload.route=[this.commonService.getRoute({ route: AirAppRoutes.Manager.DATA_UPLOAD, type: 'Manager' })];
    this.features.admin.routes = [this.commonService.getRoute({ route: AirAppRoutes.Manager.USER_CONTROL, type: 'Manager' })];
    this.features.exceptionManagement.routes = [
      this.commonService.getRoute({ route: AirAppRoutes.Manager.EVENTS, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.VESSELS, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.EXCEPTION, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.BUSINESS_RULE, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.UNLOC, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.ADD_VESSEL, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.EDIT_VESSEL, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.PORT_MANAGEMENT, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.CUSTOMER_MANAGEMENT, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.CARRIERS_SCAC_MANAGEMENT, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.ADD_EVENT_TO_MULTIPLE_SHIPMENT, type: 'Manager' }),
      this.commonService.getRoute({ route: AirAppRoutes.Manager.PETA_MANAGEMENT, type: 'Manager' }),
    ];
    this.userControlService.$userFeatures.subscribe((featureList: any) => {
      if (featureList) {
        featureList.map((feature: any) => {
          switch (feature.name) {
            case EFeatures.LIVE_TRACKING: {
              this.features.liveTracking.access = true;
              break;
            }
            case EFeatures.EXCEPTION_MANAGEMENT: {
              this.features.exceptionManagement.access = true;
              break;
            }
            case EFeatures.ADMIN: {
              this.features.admin.access = true;
              break;
            }
            case EFeatures.EVENT_TRACKING: {
              this.features.eventTracking.access = true;
              break;
            }
            case EFeatures.REPORTING: {
              this.features.reporting.access = true;
              break;
            }
            case EFeatures.DATA_UPLOAD: {
              this.features.dataUpload.access = true;
              break;
            } 
          }
        })
      }
    });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.features.exceptionManagement.routes.indexOf(state.url) >= 0) {
      if (this.features.exceptionManagement.access) {
        return true;
      } else {
        this.authService.loginRedirect();
        return false;
      }
    }

    if (this.features.admin.routes.indexOf(state.url) >= 0) {
      if (this.features.admin.access) {
        return true;
      } else {
        this.authService.loginRedirect();
        return false;
      }
    }
    if (this.features.reporting.routes.indexOf(state.url) >= 0) {
      if (this.features.reporting.access) {
        return true;
      } else {
        this.authService.loginRedirect();
        return false;
      }
    }
    if (this.features.dataUpload.routes.indexOf(state.url) >= 0) {
      if (this.features.dataUpload.access) {
        return true;
      } else {
        this.authService.loginRedirect();
        return false;
      }
    }
    return true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.features.exceptionManagement.routes.indexOf(state.url) >= 0) {
      if (this.features.exceptionManagement.access) {
        return true;
      } else {
        this.authService.loginRedirect();
        return false;
      }
    }

    if (this.features.admin.routes.indexOf(state.url) >= 0) {
      if (this.features.admin.access) {
        return true;
      } else {
        this.authService.loginRedirect();
        return false;
      }
    }
    if (this.features.reporting.routes.indexOf(state.url) >= 0) {
      if (this.features.reporting.access) {
        return true;
      } else {
        this.authService.loginRedirect();
        return false;
      }
    }
    if (this.features.dataUpload.routes.indexOf(state.url) >= 0) {
      if (this.features.dataUpload.access) {
        return true;
      } else {
        this.authService.loginRedirect();
        return false;
      }
    }
    return true;
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
 //   console.log('canLoad');
    return true;
  }
}
